import { FC } from 'react';
import { StaleLoader, Row, Title } from 'components';
import { TitleLoaderWrapper } from './TitleLoader.styles';

interface OwnProps {
  title?: string;
}

const TitleLoader: FC<OwnProps> = ({ title }) => {
  return (
    <TitleLoaderWrapper>
      <Row mb>
        <StaleLoader size="large" />
      </Row>
      <Title variant="h5" mt>
        {title ? title : 'Loading...'}
      </Title>
    </TitleLoaderWrapper>
  );
};

export default TitleLoader;
